export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <p className="font-display text-3xl text-white tracking-wide">
            JARED DUPERE<span className="text-[#CCFF00]">.</span>
          </p>
          <p className="text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono2 mt-2">
            Former D1 &amp; SF Giants Organization
          </p>
        </div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-600 font-mono2">
          © {new Date().getFullYear()} Dupere Performance Coaching. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
